<template>
    <div v-loading="$parentInfo.dialog_UpdateClass_Semester.loading">
        <el-form :model="$parentInfo.dialog_UpdateClass_Semester.classForm" label-width="90px">

            <el-form-item label="课程学科">
                <el-input v-model="modalData.subject.name" disabled></el-input>
            </el-form-item>

            <el-form-item label="任课老师">
                <el-input v-model="modalData.teacher.name" disabled></el-input>
            </el-form-item>

            <el-form-item label="上课时间">
                <el-input :value="modalData.timeData.content[0]+modalData.timeData.content[1]" disabled></el-input>
            </el-form-item>

            <el-form-item label="开始时间">
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.start_time" placeholder="请输入" :disabled="!$parentInfo.powers.includes(175)"></el-input>
            </el-form-item>

            <el-form-item label="时长">
                <el-select v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.duration"
                           filterable remote clearable
                           placeholder="请选择时长"
                           @change="change_duration">
                    <el-option
                            v-for="item in durations"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.note" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="教室">
                <el-select v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.classroom_id"
                           filterable remote clearable :remote-method="handleSearchClassroom"
                           placeholder="请选择教室"
                           :loading="$parentInfo.dialog_UpdateClass_Semester.search_loading">
                    <el-option
                            v-for="item in $parentInfo.classrooms"
                            :key="item.id"
                            :label="item.complete_name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="年级">
                <el-radio-group v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.grade_id" size="mini"
                                @change="classNameChange">
                    <el-radio-button border v-for="(item,index) in $parentInfo.grades"
                                     :label="item.id" :key="index">{{item.name}}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="班级类型">
                <el-radio-group v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.class_type_id" size="mini"
                                :disabled="!$parentInfo.dialog_UpdateClass_Semester.classForm.name"
                                @change="classTypeChange($parentInfo.dialog_UpdateClass_Semester.classForm.class_type_id,'class_type')">
                    <template v-if="modalData.subject.id!==24">
                        <el-radio-button :label="1">一对一</el-radio-button>
                        <el-radio-button :label="4">一对二</el-radio-button>
                        <el-radio-button :label="2">一对三</el-radio-button>
                        <el-radio-button :label="6">一对六</el-radio-button>
                        <el-radio-button :label="3">小班</el-radio-button>
                    </template>
                    <el-radio-button v-else :label="5">晚托</el-radio-button>

                </el-radio-group>
            </el-form-item>

            <el-form-item label="班型">
                <el-radio-group v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.type" size="mini" @change="typeChange()">
                    <el-radio-button :label="1">普通</el-radio-button>
                    <el-radio-button :label="2">衔接</el-radio-button>
                    <el-radio-button :label="3">Ti</el-radio-button>
                    <el-radio-button :label="7">全日制</el-radio-button>
                    <el-radio-button :label="4">试听</el-radio-button>
                    <el-radio-button :label="5" disabled>综评辅导</el-radio-button>
                    <el-radio-button :label="6" v-if="$parentInfo.filter.section_id==4">网络</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="冲刺课">
                <el-checkbox v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.sprintClass"
                             disabled></el-checkbox>
            </el-form-item>

            <el-form-item label="课程名称">
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.name"></el-input>
            </el-form-item>

            <el-form-item label="初始总课次">
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.original_period"
                          disabled></el-input>
            </el-form-item>

            <el-form-item label="当前总课次">
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.period" disabled></el-input>
            </el-form-item>

            <el-form-item label="单价"  v-if="$parentInfo.filter.section_id!==4">
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.unit_period_price" :disabled="!$parentInfo.powers.includes(183)"></el-input>
            </el-form-item>
            <el-form-item label="单价(课时)" v-else>
                <el-input v-model="$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour" disabled></el-input>
            </el-form-item>

            <el-form-item>
                <el-button v-if="powers.includes(51)" size="small" @click="handleStore"
                           :loading="$parentInfo.dialog_UpdateClass_Semester.button_loading">
                    修改保存
                </el-button>
                <el-button v-if="powers.includes(52)" size="small" @click="handleDelete"
                           :loading="$parentInfo.dialog_UpdateClass_Semester.button_loading">
                    删除
                </el-button>
                <el-button v-if="powers.includes(145)" size="small" @click="handleCancel"
                           :loading="$parentInfo.dialog_UpdateClass_Semester.button_loading">
                    取消
                </el-button>
                <el-button v-if="powers.includes(145)" size="small" @click="handleFinished"
                           :loading="$parentInfo.dialog_UpdateClass_Semester.button_loading">
                    结课
                </el-button>
                <el-button size="mini" type="success" @click="handleGoToMonthlyTimeTable()"
                           v-if="powers.indexOf(106)">进入月课表
                </el-button>
                <!--<el-button size="mini" type="success" @click="handleClassInformation()"-->
                           <!--v-if="powers.indexOf(106)">课程信息-->
                <!--</el-button>-->
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Dialog_UpdateClass_Semester",
        data() {
            return {
                course: {},
                durations:[{
                    id:1.5,
                    name:'1.5小时'
                },{
                    id:1,
                    name:'1小时'
                },{
                    id:0.75,
                    name:'45分钟'
                }]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowClass();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            modalData() {
                return this.$store.state.modal.data;
            },
            classTypes() {
                return JSON.parse(localStorage.config).classTypes;
            },
        },
        methods: {
            handleShowClass() {
                this.$wApi.send(this.$parentInfo.path, 'get_class', {
                    // 'id':this.$parentInfo.cell.classx.class_id,
                    'semester_id': this.$parentInfo.filter.semester_id,
                    'subject_id': this.$store.state.modal.data.subject.id,
                    'class_id': this.$store.state.modal.data.class.class_id,
                    'template_time_semester_id': this.$store.state.modal.data.timeData.template_time_semester_id,
                });
            },
            handleStore() {
                this.$parentInfo.dialog_UpdateClass_Semester.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'update_class', {
                    'id': this.$store.state.modal.data.class.class_id,
                    'name': this.$parentInfo.dialog_UpdateClass_Semester.classForm.name,
                    'note': this.$parentInfo.dialog_UpdateClass_Semester.classForm.note,
                    'grade_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.grade_id,
                    'unit_period_price': this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_period_price,
                    'class_type_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.class_type_id,
                    'template_time_semester_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.template_time_semester_id,
                    'classroom_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.classroom_id,
                    'type': this.$parentInfo.dialog_UpdateClass_Semester.classForm.type,
                    // 'subject_id': this.$parentInfo.classForm.subject_id,
                    // 'teacher_id': this.$parentInfo.classForm.teacher_id,
                    'semester_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.semester_id,
                    'period': this.$parentInfo.dialog_UpdateClass_Semester.classForm.period,
                    'original_period': this.$parentInfo.dialog_UpdateClass_Semester.classForm.original_period,
                    'duration': this.$parentInfo.dialog_UpdateClass_Semester.classForm.duration,
                    'unit_classHour': this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour,
                    'start_time': this.$parentInfo.dialog_UpdateClass_Semester.classForm.start_time,
                });
            },
            handleDelete() {
                this.$confirm('是否删除该课程?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_UpdateClass_Semester.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'delete_class', {
                        'class_id': this.$store.state.modal.data.class.class_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleCancel() {
                this.$confirm('是否取消该课程?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_UpdateClass_Semester.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'cancel_class', {
                        'class_id': this.$store.state.modal.data.class.class_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleFinished() {
                this.$confirm('是否要结算该课程?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_UpdateClass_Semester.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'finish_class', {
                        'class_id': this.$store.state.modal.data.class.class_id,
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            classNameChange() {
                this.$parentInfo.dialog_CreateClass_Semester.classForm.type=1;
                this.$parentInfo.dialog_UpdateClass_Semester.classForm.class_type_id = 0;
                this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_period_price = 0;
                this.$wApi.send(this.$parentInfo.path, 'get_course', {
                    'grade_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.grade_id,
                    'subject_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.subject_id,
                    'class_type_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.class_type_id,
                    'semester_id': this.modalData.semester.id,
                    'type': 'update',
                });
            },
            classTypeChange(val) {
                this.$parentInfo.dialog_UpdateClass_Semester.classForm.type='';
                this.$parentInfo.dialog_UpdateClass_Semester.classForm.name = this.$parentInfo.grades[this.$parentInfo.dialog_UpdateClass_Semester.classForm.grade_id].name +
                    this.$parentInfo.subjects[this.$parentInfo.cell.subject_id].name;
                this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_period_price = 0;
                this.$parentInfo.dialog_UpdateClass_Semester.courses.forEach((item) => {
                    if (item.class_type_id === val) {
                        this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_period_price = item.unit_period_price;
                        if (status === 'type') {
                            this.$parentInfo.dialog_UpdateClass_Semester.classForm.period = item.period
                        }
                    }
                });
                this.$parentInfo.dialog_UpdateClass_Semester.classForm.name = this.$parentInfo.dialog_UpdateClass_Semester.classForm.name + this.$parentInfo.class_types[val].name;
            },
            handleSearchClassroom(query) {
                this.$parentInfo.dialog_UpdateClass_Semester.search_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'search_classroom', {
                    'classroom_name': query,
                    'template_time_semester_id': this.$parentInfo.dialog_UpdateClass_Semester.classx.template_time_semester_id,
                    'class_id': this.$parentInfo.dialog_UpdateClass_Semester.classx.class_id,
                    'class_type_id': this.$parentInfo.dialog_UpdateClass_Semester.classx.class_type_id,
                    'semester_id': this.$parentInfo.dialog_UpdateClass_Semester.classForm.semester_id
                });
            },
            handleGoToMonthlyTimeTable() {
                this.$Win.closeModal();
                this.$Win.openModal('Dialog_MonthlyTable',  1800, 900,this.$parentInfo.dialog_UpdateClass_Semester.classForm.name, {
                    'class_id':this.$store.state.modal.data.class.class_id
                },true);
            },
            handleClassInformation(){
                this.$Win.closeModal();
                this.$parentInfo.Dialog_ClassInformation.class_id=this.$store.state.modal.data.class.class_id
                this.$Win.openModal('Dialog_ClassInformation',  1800, 900,'课程信息-'+this.$parentInfo.dialog_UpdateClass_Semester.classForm.name, {},true);
            },
            change_duration(){
                if(this.$parentInfo.dialog_UpdateClass_Semester.classForm.duration===1){
                    this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour=1;
                }else if(this.$parentInfo.dialog_UpdateClass_Semester.classForm.duration===1.5){
                    this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour=1.5;
                }
            },
            typeChange(){
                if(this.$parentInfo.dialog_UpdateClass_Semester.classForm.type==7){
                    this.$parentInfo.dialog_UpdateClass_Semester.classForm.duration=0.75
                    this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour=0.75;
                }else{
                    if(this.$parentInfo.filter.section_id===4){
                        this.$parentInfo.dialog_UpdateClass_Semester.classForm.duration=1;
                        this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour=1;
                    }else{
                        this.$parentInfo.dialog_UpdateClass_Semester.classForm.duration=1.5
                        this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_classHour=1.5;
                    }
                }
                if([2,3].includes(this.$parentInfo.dialog_CreateClass_Semester.classForm.type)){
                    this.$parentInfo.dialog_UpdateClass_Semester.courses.forEach((item) => {
                        if (item.class_type_id ===8 && this.$parentInfo.dialog_UpdateClass_Semester.classForm.type==3) {
                            this.$parentInfo.dialog_UpdateClass_Semester.classForm.unit_period_price = item.unit_period_price;
                            this.$parentInfo.dialog_UpdateClass_Semester.classForm.period = item.period
                        }
                    });
                }
            }
        }
    }
</script>

<style>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3000;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
</style>
